import clsx from 'clsx'

import { type BookingStatus } from '@/types/Booking'

export const getDisplayPatientVip = (value: boolean): string => {
  return value ? 'Yes' : 'No'
}

export const getStatusBgColor = (status: BookingStatus): string => {
  switch (status) {
    case 'Approved':
      return clsx('bg-primary-200')

    case 'Cancelled':
      return clsx('bg-danger-200')

    case 'Completed':
      return clsx('bg-success-200')

    case 'No-show':
      return clsx('bg-warning-200')

    default:
      return clsx('bg-neutral-200')
  }
}
